/**
 * Envío ND-1 · Qwen3 TTS: voces válidas y requisitos por modo.
 * Fuente: https://replicate.com/qwen/qwen3-tts (input `speaker`, modo custom_voice).
 */
import { missingOf, need, textNeed } from './nodeRequirements';

// Voces preestablecidas que acepta qwen/qwen3-tts en Replicate (modo custom_voice).
// El `id` va tal cual al modelo: respetar mayúsculas y guiones bajos.
export const SPEAKERS = [
  { id: 'Aiden', label: 'Aiden', gender: 'M' },
  { id: 'Dylan', label: 'Dylan', gender: 'M' },
  { id: 'Eric', label: 'Eric', gender: 'M' },
  { id: 'Ono_anna', label: 'Ono Anna', gender: 'F' },
  { id: 'Ryan', label: 'Ryan', gender: 'M' },
  { id: 'Serena', label: 'Serena', gender: 'F' },
  { id: 'Sohee', label: 'Sohee', gender: 'F' },
  { id: 'Uncle_fu', label: 'Uncle Fu', gender: 'M' },
  { id: 'Vivian', label: 'Vivian', gender: 'F' },
];
export const DEFAULT_SPEAKER = 'Serena';

/** Voz guardada en un nodo viejo que ya no existe → la voz por defecto. */
export const validSpeaker = (value) => {
  const hit = SPEAKERS.find((v) => v.id.toLowerCase() === String(value || '').toLowerCase());
  return hit ? hit.id : DEFAULT_SPEAKER;
};

/** Lo que falta (y lo opcional) para generar en cada modo. Función pura (testeada). */
export function qwenRequirements({ mode, text, speaker, voiceDescription, hasReference, referenceConnected }) {
  const missing = [textNeed(text, 'escribir el texto a locutar')];
  const optional = [];
  if (mode === 'voice_clone') {
    missing.push(hasReference ? null : referenceConnected
      ? 'que el nodo de audio conectado tenga resultado: generalo primero'
      : 'un audio de referencia con la voz a clonar (3 s o más): cargalo o conectalo');
    optional.push('la transcripción del audio de referencia (recomendada)');
  } else if (mode === 'voice_design') {
    missing.push(textNeed(voiceDescription, 'describir la voz que querés'));
  } else {
    missing.push(need(SPEAKERS.some((v) => v.id === speaker), 'elegir una voz de la lista'));
  }
  optional.push('el estilo o la emoción');
  return { missing: missingOf(missing), optional };
}
